// extracted by mini-css-extract-plugin
export var clauseRow = "_af-6";
export var emptyState = "_af-b";
export var filterContent = "_af-a";
export var filterGroup = "_af-1";
export var filterGroupContainer = "_af-0";
export var nestedGroup = "_af-2";
export var nestedGroupDepth1 = "_af-3";
export var nestedGroupDepth2 = "_af-4";
export var nestedGroupDepth3 = "_af-5";
export var operatorAnd = "_af-8";
export var operatorOr = "_af-9";
export var operatorToggle = "_af-7";
export var removeGroupButton = "_af-c";